import { FEATURE_FLAGS_NAMES, SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

const useScimSetting = () => {
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();
  const isScimEnabledFF = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isScimEnabled
  });
  const value = getSettingOrDefinitionValue({
    name: SettingValues.SCIM_PROVISIONING_SETTINGS
  });

  const isEnabled = isScimEnabledFF && value.isScimEnabled;

  const disabledTooltip = 'Managed by SCIM provider';

  const toggleActivision = async () => {
    await updateSetting(SettingValues.SCIM_PROVISIONING_SETTINGS, {
      ...value,
      isScimEnabled: !isEnabled
    });
  };

  return {
    isEnabled,
    value,
    disabledTooltip,
    toggleActivision
  };
};

export default useScimSetting;
